<template>
    <div class="locations">
        <h2 class="locations__title">Nuestras sedes</h2>

        <div class="locations__content">
            <ul class="locations__list">
                <li v-for="(loc, index) in locations" :key="index" class="location" :class="[ getClass(loc) ]" @click="handleClick(loc)">
                    <h3 class="location__title">{{ loc.title }}</h3>
                    <p class="location__address">{{ loc.address }}</p>
                </li>
            </ul>

            <p class="locations__address">{{ location.address }}</p>
            <GoogleMap :key="location.id" class="location__map" :latitude="location.latitude" :longitude="location.longitude"
                :address="location.address" hide-tags popup></GoogleMap>
        </div>
    </div>
</template>

<script>
import GoogleMap from '@/web/appraisal/components/GoogleMap';

export default {
    components: {
        GoogleMap,
    },
    props: {
        locations: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            location: this.locations[0],
        };
    },
    methods: {
        handleClick(loc) {
            this.location = loc;
        },
        getClass(loc) {
            return this.location.id === loc.id ? 'location--active' : '';
        },
    },
};
</script>
  